import { useEffect } from 'react';

const HowToUse = () => {
    useEffect(() => {
        window.location.href = 'https://youtu.be/iC1TQlQQ2m0';
    }, []);

    return <div>Redirecting...</div>;
};

export default HowToUse;